import { Controller } from '@hotwired/stimulus'
import { application } from './application'

let asyncControllerLoaded = false

export default class extends Controller {
  connect () {
    if (!asyncControllerLoaded) {
      asyncControllerLoaded = true
      import('./bar_stacked_chart_controller_async').then((controller) => {
        application.load([{ identifier: 'bar-stacked-chart', controllerConstructor: controller.default }])
      }, () => { })
    }
  }
}
